// actions.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const API_URL = process.env.REACT_APP_API_URL;

export const login = (username, password, rememberMe) => {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/api/login`, {
        username,
        password,
      });
      const { token } = response.data; // トークンを取得
      console.log("token:", token);
      const decodedToken = jwtDecode(token);
      const role = decodedToken.role;
      const expirationTime = decodedToken.exp * 1000;

      localStorage.setItem("token", token);
      localStorage.setItem("role", role);

      sessionStorage.setItem("token", token);
      localStorage.setItem("expirationTime", expirationTime);

      dispatch({ type: "LOGIN_SUCCESS", payload: { token, role } });
      // dispatch(restoreRole(role));

      return { token, role };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "ログインに失敗しました。";
      dispatch({ type: "LOGIN_FAILURE", payload: errorMessage });
      console.log(error);
      throw error;
    }
  };
};

export const restoreRole = (role) => {
  return (dispatch) => {
    dispatch({ type: "RESTORE_ROLE", payload: role });
  };
};

export const restoreSession = (token) => {
  return (dispatch) => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const decodedToken = jwtDecode(token);
    const role = decodedToken.role;

    dispatch({ type: "LOGIN_SUCCESS", payload: { token, role } });
  };
};

export const logout = () => {
  return (dispatch) => {
    localStorage.removeItem("token"); // トークンを削除
    localStorage.removeItem("username"); // ユーザー名を削除
    localStorage.removeItem("role"); // ユーザー名を削除
    localStorage.removeItem("expirationTime");

    dispatch({ type: "LOGOUT" });
  };
};
